import React from "react";
import PropTypes from "prop-types";

const SketchfabViewer = ({modelURL, sketchfabUser="xaek5", modelName="3Dmodel", width=640, height=480}) => {
  const iframe = (
    <iframe
      title={modelName}
      width={width}
      height={height}
      src={`${modelURL}/embed?preload=1&amp;ui_controls=1&amp;ui_infos=1&amp;ui_inspector=1&amp;ui_stop=1&amp;ui_watermark=1&amp;ui_watermark_link=1`}
      frameBorder="0"
      allow="autoplay;"
      mozallowfullscreen="true"
      webkitallowfullscreen="true"
    ></iframe>
  );

  return (
    <>
      <div className="sketchfab-embed-wrapper">
        {iframe}
        <p
          style={{
            fontSize: "13px",
            fontWeight: "normal",
            margin: "5px",
            color: "#4A4A4A",
          }}
        >
          <a
            href={`${modelURL}?utm_medium=embed&utm_source=website&utm_campaign=share-popup`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontWeight: "bold", color: "#1CAAD9" }}
          >
            {modelName} 
          </a>
          {" by "}
          <a
            href={`https://sketchfab.com/${sketchfabUser}?utm_medium=embed&utm_source=website&utm_campaign=share-popup`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontWeight: "bold", color: "#1CAAD9" }}
          >
            {sketchfabUser}
          </a>
          {" on "}
          <a
            href="https://sketchfab.com?utm_medium=embed&utm_source=website&utm_campaign=share-popup"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontWeight: "bold", color: "#1CAAD9" }}
          >
            Sketchfab
          </a>
        </p>
      </div>
    </>
  );
};

SketchfabViewer.prototypes = {
  modelURL: PropTypes.string.isRequired,
};

export default SketchfabViewer;
